import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import CancelNavigatingAwayFromFlowPopup from 'components/common/PortalModal/popups/CancelNavigatingAwayFromFlowPopup';
import { TRANSACTION_ADD_PREFIX } from 'constants';
import useNotificationStore from 'features/notification/hooks/useNotificationStore';
import useNotify from 'hooks/useNotify';
import usePortalModal from 'hooks/usePortalModal';
import { domUtils } from 'utils';

const CancelNavigatingAwayFromFlowModal = ({ isShow, modalStyles }) => {
  const { closePortalModalName } = usePortalModal();
  const { currentNotifyData, setCurrentNotifyData } = useNotificationStore();

  const { handleNotifyOnClick } = useNotify();

  const { alignContent } = modalStyles || {};

  const handleOnClickCancelPopup = () => {
    domUtils.changeAddressBarUrlWithoutReloadPage({
      prefix: TRANSACTION_ADD_PREFIX,
    });

    handleNotifyOnClick(null, currentNotifyData, true);
  };

  const handleOnClick = () => {
    handleOnClickCancelPopup();
    closePortalModalName();
  };

  const handleOnClose = () => {
    setCurrentNotifyData(null);
    closePortalModalName();
  };

  return (
    <CancelNavigatingAwayFromFlowPopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
      }}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      modalStyles={modalStyles}
      alignContent={alignContent}
    />
  );
};

export default CancelNavigatingAwayFromFlowModal;
